import styled from 'styled-components';

import colors from '../../../../../styles/colors';

import Button from '../../../../../components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  font-size: 14px;
  text-wrap: nowrap;
  padding: 5px 15px;
  border-radius: 5px;
  background-color: ${({ $isSelected }) => ($isSelected ? colors.base.primary : colors.base.gamma)};
`;

export {
  Container,
  StyledButton,
};
